import { APP_ENVIRONMENT_CONSTANTS } from 'common/constants/appEnvironmentConstants'
import { env } from 'common/utils/env'

// Everything Series, badge included, is development-only for now.
export const SHOW_SERIES = env.ENV === APP_ENVIRONMENT_CONSTANTS.DEVELOPMENT
